
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("44FvL", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $8EyOs = parcelRequire("8EyOs");


var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $jMyy4 = parcelRequire("jMyy4");


var $aJv6Q = parcelRequire("aJv6Q");


var $3Xs1I = parcelRequire("3Xs1I");

var $c0urc = parcelRequire("c0urc");


var $qP1yw = parcelRequire("qP1yw");








var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");

const $02b5fb906cf465ad$var$styling = (0, $ecnYn.xcss)({
    borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    display: 'inline-block',
    width: '1px',
    height: '16px',
    marginBlock: 'space.0',
    marginRight: 'space.050',
    marginLeft: 'space.100',
    alignSelf: 'center'
});
const $02b5fb906cf465ad$export$9bdbf4502c13e864 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "vertical-line",
            xcss: $02b5fb906cf465ad$var$styling
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};


const $a8f24b4bd469814d$export$f29be0a8efdebc38 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { contentId: contentId, isDraft: isDraft, hasSeparator: hasSeparator } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== isDraft) {
        t1 = {
            fetchPolicy: "cache-and-network",
            variables: {
                contentId: contentId,
                isDraft: isDraft,
                format: "USER_FRIENDLY"
            }
        };
        $[0] = contentId;
        $[1] = isDraft;
        $[2] = t1;
    } else t1 = $[2];
    const { data: data, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8EyOs.default), {
        ...t1,
        __callerPackage__: "@confluence/content-state"
    });
    if (!data) return null;
    const contentState = data?.singleContent?.contentState;
    let t2;
    if ($[3] !== contentId || $[4] !== contentState || $[5] !== hasSeparator || $[6] !== isDraft) {
        t2 = contentState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $qP1yw.LazyRendererContentStateComponent), {
            contentId: contentId,
            contentState: contentState,
            isDraft: isDraft
        }), !isDraft && hasSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02b5fb906cf465ad$export$9bdbf4502c13e864), null));
        $[3] = contentId;
        $[4] = contentState;
        $[5] = hasSeparator;
        $[6] = isDraft;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $c0urc.ReloadType).content
        ];
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== refetch) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Xs1I.QuickReloadSubscriber), {
            name: "content-state",
            types: t3,
            reload: refetch
        });
        $[9] = refetch;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t2 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t2, t4);
        $[11] = t2;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};
const $a8f24b4bd469814d$export$cbe74da24be93fbd = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($a8f24b4bd469814d$export$f29be0a8efdebc38);
module.exports["RendererContentStateImpl"] = $a8f24b4bd469814d$export$f29be0a8efdebc38;
module.exports["RendererContentState"] = $a8f24b4bd469814d$export$cbe74da24be93fbd;

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<dd6200b047aed134b0d9af6a992daf7b>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("qP1yw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $lJswu = parcelRequire("lJswu");


var $dzxx6 = parcelRequire("dzxx6");


const $d4d6077acc6972b1$export$a5601a59fc831df9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qET7f",
    name: "LazyEditorContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("7GxfY"))).EditorContentStateComponent;
    },
    loading: (0, $lJswu.ContentStateSkeleton)
});

const $d4d6077acc6972b1$export$c49c9d91fa2cc91e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "OYB6O",
    name: "LazyRendererContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("9EUwJ"))).RendererContentStateComponent;
    },
    loading: (0, $dzxx6.RendererContentStatePlaceholder)
});
module.exports["LazyEditorContentStateComponent"] = $d4d6077acc6972b1$export$a5601a59fc831df9;
module.exports["LazyRendererContentStateComponent"] = $d4d6077acc6972b1$export$c49c9d91fa2cc91e;

});

parcelRegister("lJswu", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kpYGL = parcelRequire("kpYGL");

const $668f42f1e7477ee9$export$ad2edbf08e0f7b11 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "60px",
            height: "20px",
            isShimmering: true,
            testId: "content-state-skeleton"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentStateSkeleton"] = $668f42f1e7477ee9$export$ad2edbf08e0f7b11;

});

parcelRegister("dzxx6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");


var $bUlM5 = parcelRequire("bUlM5");

const $62a49c8d20755563$var$loadingPlaceholderStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    minHeight: '32px',
    borderRadius: 'radius.small',
    paddingRight: 'space.100',
    backgroundColor: 'utility.elevation.surface.current'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$ContentStateNamePlaceholderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_k48p1wq8 _3um015vq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62a49c8d20755563$var$contentStateColorPlaceholderStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full',
    height: '10px',
    width: '10px',
    marginLeft: 'space.050',
    marginRight: 'space.075',
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$flexWrapperStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075',
    marginRight: 'space.075'
});
const $62a49c8d20755563$export$6679211e6c7373d = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { contentState: contentState } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $62a49c8d20755563$var$contentStateColorPlaceholderStyles,
            testId: "subtle-renderer-content-state-color-placeholder"
        });
        $[0] = t1;
    } else t1 = $[0];
    const t2 = contentState?.name;
    let t3;
    if ($[1] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $62a49c8d20755563$var$flexWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            as: "li",
            alignItems: "center",
            xcss: $62a49c8d20755563$var$loadingPlaceholderStyles,
            testId: "subtle-renderer-content-state-placeholder"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62a49c8d20755563$var$ContentStateNamePlaceholderWrapper, null, t2)));
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
};
module.exports["RendererContentStatePlaceholder"] = $62a49c8d20755563$export$6679211e6c7373d;

});

parcelRegister("7GxfY", function(module, exports) {

let $598640b5c09144c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $598640b5c09144c1$var$load("jf18J"),
    $598640b5c09144c1$var$load("1F2Py"),
    $598640b5c09144c1$var$load("lJ0p6"),
    $598640b5c09144c1$var$load("dZsGY"),
    $598640b5c09144c1$var$load("3dFwk"),
    $598640b5c09144c1$var$load("fFc5s"),
    $598640b5c09144c1$var$load("h4Nf7"),
    $598640b5c09144c1$var$load("el56J"),
    $598640b5c09144c1$var$load("h9S8v"),
    $598640b5c09144c1$var$load("3GuOt"),
    $598640b5c09144c1$var$load("jbM5v"),
    $598640b5c09144c1$var$load("dek7I"),
    $598640b5c09144c1$var$load("dYtBN"),
    $598640b5c09144c1$var$load("kNV5Y"),
    $598640b5c09144c1$var$load("6wr18"),
    $598640b5c09144c1$var$load("gT8XU"),
    $598640b5c09144c1$var$load("53AGa"),
    $598640b5c09144c1$var$load("8bhm4"),
    $598640b5c09144c1$var$load("5wVuh"),
    $598640b5c09144c1$var$load("4NznW"),
    $598640b5c09144c1$var$load("kHOMt"),
    $598640b5c09144c1$var$load("ffEVr"),
    $598640b5c09144c1$var$load("guVy6"),
    $598640b5c09144c1$var$load("7s1i1"),
    $598640b5c09144c1$var$load("8k9aB"),
    $598640b5c09144c1$var$load("fLwVm"),
    $598640b5c09144c1$var$load("1bbSu"),
    $598640b5c09144c1$var$load("kuFG2"),
    $598640b5c09144c1$var$load("Wowvf"),
    $598640b5c09144c1$var$load("hhss7"),
    $598640b5c09144c1$var$load("7EorR"),
    $598640b5c09144c1$var$load("9DDT5")
]).then(()=>parcelRequire('2TweP'));

});

parcelRegister("9EUwJ", function(module, exports) {

let $7083b28f0e74da40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7083b28f0e74da40$var$load("jcEo4").then(()=>parcelRequire('llcSD'));

});

parcelRegister("1SNEF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $42omo.useContext)((0, $c0urc.QuickReloadContext));
    (0, $42omo.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("1vpkQ", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
const $f378941f4cbfa1d0$export$e439c3cb9ea2e5e3 = 'confluence.approvals.pane.contextKey';
const $f378941f4cbfa1d0$export$bbf9a6919720fa3a = 'CURRENT';
const $f378941f4cbfa1d0$export$74a7304e4ecb72ad = 'DRAFT';
const $f378941f4cbfa1d0$export$effd283748674146 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
/**
 * In-memory cache of the approvals pane context key.
 *
 * When the `confluence_browser_storage_controls` feature gate is enabled,
 * `sessionStorageManager.setItem` delegates to `AtlBrowserStorageSession.setItem`
 * which is **async** (it awaits IndexedDB consent checks before writing to
 * `sessionStorage`). This means a synchronous read immediately after a write
 * will return `null` — the value hasn't been persisted yet.
 *
 * The ownership helpers (`shouldRenderApprovalsPaneForContext`,
 * `syncApprovalsPaneContextOwnership`) run synchronously during React renders
 * and effects, so they need a synchronous source of truth. This in-memory
 * variable serves that purpose. Session storage is still written for
 * durability across page reloads, but in-session reads use this cache.
 */ let $f378941f4cbfa1d0$var$inMemoryContextKey = null;
const $f378941f4cbfa1d0$export$7df64ccaccec4e24 = ()=>$f378941f4cbfa1d0$var$inMemoryContextKey;
const $f378941f4cbfa1d0$export$d4f550c493c9338 = (contextKey)=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = contextKey;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3, contextKey);
};
const $f378941f4cbfa1d0$export$fbd6783260490074 = ()=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
};
const $f378941f4cbfa1d0$export$823b1a6d7b43bfe4 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $f378941f4cbfa1d0$export$41945f41a6acb22 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalsExperimentEnabled || !isSidebarApprovalsPaneOpen) return false;
    return $f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: $f378941f4cbfa1d0$export$7df64ccaccec4e24()
    });
};
const $f378941f4cbfa1d0$export$f29b4d98dbe0b579 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey, closeApprovalsPane: closeApprovalsPane })=>{
    if (!isApprovalsExperimentEnabled) return;
    if (!isSidebarApprovalsPaneOpen) {
        $f378941f4cbfa1d0$export$fbd6783260490074();
        return;
    }
    const storedContextKey = $f378941f4cbfa1d0$export$7df64ccaccec4e24();
    if ($f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalsPane();
    $f378941f4cbfa1d0$export$fbd6783260490074();
};
const $f378941f4cbfa1d0$export$c922f15693c980c9 = ({ contentId: contentId, contentStatus: contentStatus, rightSidebarContext: rightSidebarContext })=>{
    $f378941f4cbfa1d0$export$d4f550c493c9338($f378941f4cbfa1d0$export$effd283748674146({
        contentId: contentId,
        contentStatus: contentStatus
    }));
    rightSidebarContext.open($f378941f4cbfa1d0$export$64c46cf06596fc50, $f378941f4cbfa1d0$export$48f59b832d015459);
};
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_CURRENT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$bbf9a6919720fa3a;
module.exports["getApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$effd283748674146;
module.exports["getStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$7df64ccaccec4e24;
module.exports["clearStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$fbd6783260490074;
module.exports["syncApprovalsPaneContextOwnership"] = $f378941f4cbfa1d0$export$f29b4d98dbe0b579;
module.exports["openApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$c922f15693c980c9;

});


//# sourceMappingURL=RendererContentState.374c462f.js.map
